import { useForm } from "react-hook-form";
import { Task, UpdateTaskRequest } from "../../../../types/task";
import { useGetTaskByIdQuery, useUpdateTaskMutation, useUpdateTaskStatusMutation } from "../../../../api/tareas/tareaApi";
import { CircularProgress } from "@mui/joy";
import { useEffect, useState } from "react";
import { getErrorMessage } from "../../../../utils/errorHelpers";
import { ErrorMessage } from "../../../../components/errors/ErrorMessage";
import { Information } from "./Information";
import { Description } from "./Desciption";
import { TitleInput } from "./TitleInput";
import { ChangeStatusButtons } from "./ChangeStatusButtons";
import { UpdateTaskInfoButton } from "./UpdateTaskInfoButton";

interface Props {
    taskId: number;
    showNavButton?: boolean;
}

export function TaskDetail({ taskId }: Props) {
    const [errorMessage, setErrorMessage] = useState<string | null>(null);

    const { data: task, isLoading, isFetching, isSuccess } = useGetTaskByIdQuery(taskId);
    const [changeTaskStatus, { isLoading: changeStatusIsLoading }] = useUpdateTaskStatusMutation();
    const [updateTask, { isLoading: updateTaskLoading }] = useUpdateTaskMutation();

    const {
        register,
        handleSubmit,
        reset,
        watch,
        formState: { isDirty }
    } = useForm<Task>({
        values: task,
        resetOptions: {
            keepDirtyValues: true,
        }
    });

    const showRecordatorioTimes = watch("recordatorioActivado", false);

    const submitTaskUpdate = handleSubmit(async (data: Task) => {
        setErrorMessage(null);

        const request: UpdateTaskRequest = {
            id: taskId,
            titulo: data.titulo,
            texto: data.descripcion,
            habilitarRecordatorio: data.recordatorioActivado,
            fechaEnvioRecordatorio: data.timeBeforeSendNotification,
        };

        if(!data.recordatorioActivado)
        {
            request.fechaEnvioRecordatorio = ""
            data.timeBeforeSendNotification = ""
        }

        const response = await updateTask(request);

        if(response.error) {
            setErrorMessage(getErrorMessage(response.error));
            return;
        }

        reset(data);
    }); 

    const submitChangeStatus = async (status: boolean) => {
        try {
            setErrorMessage(null);

            const request = {
                taskId,
                terminada: status,
            };

            await changeTaskStatus(request).unwrap();
            
        } catch (error) {
            setErrorMessage(getErrorMessage(error));
        }
    }

    if(isLoading || isFetching || !isSuccess)
        return (
            <div className="flex justify-center items-center w-full h-[450px]">
                <CircularProgress />
            </div>
        );

    return (
        <div className="h-full">
            <form autoComplete="off" onSubmit={submitTaskUpdate}>

                <div className="my-2 mx-4">
                    <TitleInput
                        task={task}
                        register={register} />

                    <div className="mb-3">
                        <Information
                            task={task}
                            showRecordatorioTimes={showRecordatorioTimes}
                            register={register} />
                    </div>

                    <Description
                        task={task}
                        register={register} />
                </div>

                {errorMessage && (
                    <div className="px-4">
                        <ErrorMessage
                        customMessage>
                            <p className="text-sm">{errorMessage}</p>
                        </ErrorMessage>
                    </div>
                )}

                <div className="flex justify-center my-4 gap-x-2">
                    <ChangeStatusButtons
                        estatus={task.estatus} 
                        isDirty={isDirty} 
                        submitChangeStatus={submitChangeStatus}
                        changeStatusIsLoading={changeStatusIsLoading} />
                    
                    <UpdateTaskInfoButton
                        isDirty={isDirty} 
                        updateTaskLoading={updateTaskLoading} />
                </div>
            </form>
        </div>
    );
}
